var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9463 10.9105L21.4815 18.4293C21.3627 20.3503 21.3034 21.3108 20.8219 22.0014C20.5838 22.3428 20.2773 22.631 19.9218 22.8475C19.2029 23.2855 18.2405 23.2855 16.3158 23.2855C14.3886 23.2855 13.425 23.2855 12.7056 22.8467C12.3499 22.6298 12.0433 22.3411 11.8053 21.9991C11.3239 21.3074 11.2659 20.3456 11.1497 18.4219L10.6963 10.9105",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57129 10.9107H23.0713M19.3631 10.9107L18.8511 9.8545C18.511 9.1529 18.3409 8.8021 18.0476 8.58331C17.9825 8.53478 17.9136 8.49161 17.8415 8.45423C17.5167 8.28571 17.1269 8.28571 16.3472 8.28571C15.5479 8.28571 15.1483 8.28571 14.818 8.4613C14.7449 8.50021 14.675 8.54513 14.6093 8.59558C14.3125 8.82323 14.1468 9.18687 13.8152 9.91415L13.361 10.9107",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4463 19.1606V14.6606",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1963 19.1606V14.6606",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.eb664449ee2c802fd07f86be0b274f1e.svg";
export { ForwardRef as ReactComponent };